module.exports = __webpack_public_path__ + "static/media/Add Product Image.43ebab4b.png";